var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8102_11101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80644 4.32132L2.80644 17.2826C2.59871 17.6633 2.49358 18.0914 2.50138 18.525C2.50918 18.9586 2.62964 19.3827 2.85092 19.7557C3.0722 20.1287 3.3867 20.4377 3.76352 20.6523C4.14034 20.867 4.56652 20.9799 5.00019 20.9801H19.0002C19.4339 20.9799 19.86 20.867 20.2369 20.6523C20.6137 20.4377 20.9282 20.1287 21.1495 19.7557C21.3707 19.3827 21.4912 18.9586 21.499 18.525C21.5068 18.0914 21.4017 17.6633 21.1939 17.2826L14.1939 4.32132C13.9787 3.92752 13.6615 3.59891 13.2755 3.36999C12.8895 3.14107 12.449 3.02026 12.0002 3.02026C11.5514 3.02026 11.1109 3.14107 10.7249 3.36999C10.3389 3.59891 10.0217 3.92752 9.80644 4.32132V4.32132Z",
    fill: "url(#paint0_linear_8102_11101)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4796 2.95716C10.9397 2.68428 11.4648 2.54028 11.9997 2.54028C12.5347 2.54028 13.0597 2.68428 13.5198 2.95716C13.98 3.23003 14.3581 3.62173 14.6147 4.09114L14.6158 4.09324L21.6148 17.0527C21.615 17.053 21.6151 17.0532 21.6153 17.0535C21.8626 17.5071 21.9877 18.0172 21.9784 18.5337C21.9692 19.0505 21.8256 19.5561 21.5618 20.0007C21.298 20.4452 20.9231 20.8135 20.474 21.0694C20.0248 21.3253 19.5168 21.4599 18.9999 21.4601H4.99972C4.48278 21.4599 3.97463 21.3253 3.52546 21.0694C3.07629 20.8135 2.70141 20.4452 2.43764 20.0007C2.17387 19.5561 2.03029 19.0505 2.02099 18.5337C2.0117 18.0172 2.13684 17.5071 2.38412 17.0536C2.38429 17.0533 2.38445 17.053 2.38462 17.0527L9.38363 4.09325L9.80595 4.32133L9.38477 4.09114C9.64132 3.62173 10.0195 3.23003 10.4796 2.95716ZM10.2278 4.55047C10.2276 4.55083 10.2274 4.55118 10.2272 4.55154L3.22831 17.5107L3.22732 17.5125C3.05948 17.8201 2.97453 18.1661 2.98083 18.5164C2.98714 18.8668 3.08447 19.2095 3.26326 19.5108C3.44206 19.8122 3.69617 20.0618 4.00064 20.2353C4.30507 20.4087 4.64937 20.5 4.99972 20.5001M10.2278 4.55047C10.4016 4.23275 10.6578 3.96763 10.9693 3.78286C11.2812 3.59789 11.6371 3.50028 11.9997 3.50028C12.3623 3.50028 12.7183 3.59789 13.0301 3.78286C13.3417 3.96765 13.5979 4.23282 13.7718 4.5506C13.7719 4.55091 13.7721 4.55122 13.7723 4.55154L20.7711 17.5107L20.7721 17.5125C20.94 17.8201 21.0249 18.1661 21.0186 18.5164C21.0123 18.8668 20.915 19.2095 20.7362 19.5108C20.5574 19.8122 20.3033 20.0618 19.9988 20.2353C19.6944 20.4087 19.3501 20.5 18.9997 20.5001C18.9998 20.5001 18.9997 20.5001 18.9997 20.5001H4.99972",
    fill: "url(#paint1_linear_8102_11101)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 7.50269C12.2646 7.50269 12.4795 7.71759 12.4795 7.98269V15.0452C12.4795 15.3103 12.2646 15.5252 11.9995 15.5252C11.7344 15.5252 11.5195 15.3103 11.5195 15.0452V7.98269C11.5195 7.71759 11.7344 7.50269 11.9995 7.50269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 17.8377C12.1956 17.8377 12.3545 17.6787 12.3545 17.4827C12.3545 17.2866 12.1956 17.1277 11.9995 17.1277C11.8035 17.1277 11.6445 17.2866 11.6445 17.4827C11.6445 17.6787 11.8035 17.8377 11.9995 17.8377ZM11.3945 17.4827C11.3945 17.1486 11.6654 16.8777 11.9995 16.8777C12.3337 16.8777 12.6045 17.1486 12.6045 17.4827C12.6045 17.8168 12.3337 18.0877 11.9995 18.0877C11.6654 18.0877 11.3945 17.8168 11.3945 17.4827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 18.1038C12.3433 18.1038 12.6214 17.8257 12.6214 17.4826C12.6214 17.1395 12.3433 16.8613 12.0002 16.8613C11.657 16.8613 11.3789 17.1395 11.3789 17.4826C11.3789 17.8257 11.657 18.1038 12.0002 18.1038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 17.1438C11.8131 17.1438 11.6614 17.2955 11.6614 17.4826C11.6614 17.6697 11.8131 17.8213 12.0002 17.8213C12.1872 17.8213 12.3389 17.6697 12.3389 17.4826C12.3389 17.2955 12.1872 17.1438 12.0002 17.1438ZM12.6214 17.4826C12.6214 17.8257 12.3433 18.1038 12.0002 18.1038C11.657 18.1038 11.3789 17.8257 11.3789 17.4826C11.3789 17.1395 11.657 16.8613 12.0002 16.8613C12.3433 16.8613 12.6214 17.1395 12.6214 17.4826Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8102_11101",
    x1: 21.2494,
    y1: 20.9801,
    x2: 2.33561,
    y2: 20.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#780228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F50000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8102_11101",
    x1: 21.7163,
    y1: 21.4601,
    x2: 1.84671,
    y2: 20.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#780228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F50000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8102_11101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.09d2f1cf97960444207cc53c8cba2c60.svg";
export { ForwardRef as ReactComponent };